import React, { useState } from "react";
import { Button, Modal } from "semantic-ui-react";
import { t } from "../../constant/translations";

export const LicenseAgreement = () => {
  const [iFrameHeight, setIFrameHeight] = useState("1800px");
  const [modalOpen, setModalOpen] = useState(false);

  const ref = React.createRef();
  return (
    <Modal
      size={"fullscreen"}
      trigger={
        <a href={"#"} onClick={() => setModalOpen(true)}>
          {t("license.terms_of_use")}
        </a>
      }
      closeIcon={true}
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      scrolling="true"
      style={{ zIndex: 909 }}
    >
      <Modal.Content>
        <iframe
          ref={ref}
          width="100%"
          src={"/license"}
          frameBorder="0"
          style={{
            minWidth: "100%",
            minHeight: "1200px",
            textAlign: "center",
            margin: "0 0",
          }}
          height={iFrameHeight}
          scrolling="false"
          onLoad={() => {
            setIFrameHeight(
              ref.current.contentWindow.document.body.scrollHeight + "px"
            );
          }}
        />
        <div style={{ textAlign: "center" }}>
          <Button
            content={t("labels.close")}
            onClick={() => setModalOpen(false)}
            primary={true}
          />
        </div>
      </Modal.Content>
    </Modal>
  );
};
